export default __webpack_public_path__ + "static/media/antp_webinars_BannerCuadro_2.2ba11cce.jpg";